import React from "react";
import { Modal } from "reactstrap";
import Button from "react-bootstrap/Button";

const ConfirmModal = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      centered
      fade={false}
      onClosed={props.onClosed}
      backdropClassName="signupModalWrapBackdrop"
      className="blackListModal"
    >
      <div className="modal-body">
        <h6>{props.title}</h6>
        {props.content && <p>{props.content}</p>}
        <div className="text-end">
        <Button variant="danger" onClick={props.onClosed} type="button" className="rounded-pill me-2 mt-2">
            No, Don’t Do It <i className="fa-solid fa-xmark"></i>
          </Button>
          {props.submitBtn ? (
            <Button variant="success" type="submit" onClick={() => props.submit(props.values, props.dirty)} className="rounded-pill me-2 mt-2">
              Yes, Do It <i className="fa-solid fa-arrow-right"></i>
            </Button>
          ) : (
            <Button variant="success" onClick={props.submit} className="rounded-pill me-2 mt-2">
              Yes, Do It <i className="fa-solid fa-arrow-right"></i>
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmModal;
